"use client";

import Link from "next/link";
import { usePathname, useSearchParams } from "next/navigation";
import { RoaMark } from "./roa-mark";

/** The wordmark, and "Entrar" on the sign-up page. (Sign-in offers "Criar conta" inside its own form: a bigger target for a thumb.) */
export function AuthHeader() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const redirectTo = searchParams.get("redirectTo");

  const isSignUp = pathname === "/auth/signup";

  const redirectQuery = redirectTo
    ? `?redirectTo=${encodeURIComponent(redirectTo)}`
    : "";

  return (
    <header className="border-b border-border lg:border-transparent">
      <div className="container mx-auto px-4 py-3 sm:px-6 sm:py-4 lg:px-8">
        <div className="flex justify-between items-center">
          <div className="text-xl font-semibold text-foreground lg:invisible">
            <Link href="/" className="inline-flex items-center max-md:min-h-11">
              <RoaMark />
            </Link>
          </div>

          {isSignUp && (
            <div className="flex items-center gap-3">
              <span className="hidden text-sm text-muted-foreground min-[400px]:inline">
                Já tem conta?
              </span>
              <Link
                href={`/auth/signin${redirectQuery}`}
                className="inline-flex min-h-11 items-center rounded-full bg-muted px-4 py-1.5 text-sm font-medium text-foreground transition-colors hover:bg-accent sm:min-h-0"
              >
                Entrar
              </Link>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
